"use strict";
// @ts-ignore
try {
    self['workbox:streams:7.3.0'] && _();
}
catch (e) { }
